import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';

import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardBody, Button, CardTitle, CardText, Row, Col, FormGroup } from 'reactstrap';
import { renderInput, renderTextArea, renderDatePicker, renderDropdown, renderMultiselect, renderCheckbox } 
from "./renderinput";


class ContactForm extends Component {
    render(){
        return (
            <FormGroup>
                <Field name="FirstName" component={renderInput} label="First Name" />
                <Field name="LastName" component={renderInput} label="LastName Date" />
                <Field name="Email" component={renderInput} label="Email" />
                <Field name="Phone" component={renderInput} label="Phone No" />
                <Field name="ContactType" component={renderInput} label="Type" />
            </FormGroup>
        )
    }
}

export default ContactForm